"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _routeMatch = require("../../utils/routeMatch");
var _setAttendeeName = _interopRequireDefault(require("../attendee/setAttendeeName"));
var _types = require("./types");
var _addDeviceEventObserverToSession = require("@studio/chime/observers/addDeviceEventObserverToSession");
var _createConfiguration = require("@studio/chime/configuration/createConfiguration");
var _attendee = require("../attendee");
var _modal = require("../modal");
var _StudioLogger = require("@studio/logger/StudioLogger");
var _getNameInitials = require("@studio/logger/utils/getNameInitials");
var _deviceUtils = require("@studio/logger/utils/deviceUtils");
var _Vendor = require("@studio/constants/Vendor");
var _SceneLayouts = require("@studio/constants/SceneLayouts");
var _program = require("../program");
var _sceneBuilder = require("@studio/program/sceneBuilder/sceneBuilder");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var LOG = new _StudioLogger.StudioLogger('createChimeMeeting');

/**
 * Creates a meeting used for webRTC (Chime) communication for a broadcast
 *
 *
 * Migration guide for `app.studio.director`:
 *
 * - Use the middleware for sendToDatadog, the logic for sending an explicit log message to datadog has
 *   been removed from this action in order to separate concerns.
 * - Remove the use of this action from SourceList, we should not be calling `createMeeting` from the SourceList container
 * - Use the `modal` reducer from `app.studio.redux` or handle `BROADCAST_CREATE_MEETING_FAILURE` in the `modal` reducer. Logic to
 *   catch an error and call the showModal action bypasses the convention we have in place for handling async action errors (see api middleware)
 * - Call checkRealtimeConnection() somewhere else, it does not belong here. It either needs an explicit call somewhere or to be handled in middleware
 *
 */
function createMeeting(settings, metricCallback, endMeetingAsHostCallback) {
  var setProgram = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  return (0, _routeMatch.withCurrentParams)(function (dispatch, _ref, getState) {
    var teamId = _ref.teamId,
      eventId = _ref.eventId,
      broadcastId = _ref.broadcastId;
    var _ref2 = settings || {},
      userNameFromURL = _ref2.userNameFromURL,
      audioInputDeviceId = _ref2.audioInputDeviceId,
      videoInputDeviceId = _ref2.videoInputDeviceId,
      presenterDescription = _ref2.presenterDescription,
      notification = _ref2.notification;
    var _getState = getState(),
      user = _getState.user,
      directorSessionId = _getState.directorSessionId,
      program = _getState.program;
    var presenterName = user ? "".concat(user.firstName, " ").concat(user.lastName) : '';
    if (userNameFromURL) {
      presenterName = userNameFromURL;
    }
    var action = {
      type: _types.BROADCAST_CREATE_MEETING,
      request: function () {
        var _request = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(apiClient) {
          var resp, meetingResponse, attendeeResponse, attendeesList, clearedProgram, attendeeId, meeting, _t, _t2, _t3, _t4, _t5, _t6, _t7, _t8, _t9, _t0;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                _context.p = 0;
                _context.n = 1;
                return apiClient.broadcast.createMeeting(teamId, eventId, broadcastId, {
                  sessionId: directorSessionId
                });
              case 1:
                resp = _context.v;
                meetingResponse = resp.meetingResponse, attendeeResponse = resp.attendeeResponse, attendeesList = resp.attendeesList; // If there are no remote users, clear the program for Director Lite
                if (setProgram && (attendeesList === null || attendeesList === void 0 ? void 0 : attendeesList.Attendees.length) === 1) {
                  clearedProgram = (0, _sceneBuilder.sceneBuilder)(_SceneLayouts.SINGLE, [], []);
                  dispatch(setProgram(_objectSpread(_objectSpread({}, clearedProgram), {}, {
                    style: program.style
                  })));
                  dispatch((0, _program.setSceneLayout)(_SceneLayouts.SINGLE));
                  LOG.info('No remote users detected, reset program state');
                }
                dispatch((0, _attendee.syncPresenterAttendeeIds)(getPresenterAttendeeIds(attendeesList)));
                attendeeId = attendeeResponse.Attendee.AttendeeId;
                dispatch((0, _setAttendeeName["default"])(attendeeId, presenterName));
                meeting = (0, _createConfiguration.createConfiguration)(meetingResponse, attendeeResponse);
                (0, _addDeviceEventObserverToSession.addDeviceEventObserverToSession)(dispatch, _modal.showModal, meeting.meetingSession);

                // this is a passed in function that sends log action to Rudderstack
                _t = metricCallback === null || metricCallback === void 0;
                if (_t) {
                  _context.n = 4;
                  break;
                }
                _t2 = metricCallback;
                _t3 = attendeeId;
                _t4 = (0, _getNameInitials.getNameInitials)(presenterName);
                _t5 = presenterDescription;
                _context.n = 2;
                return (0, _deviceUtils.getCameraNameFromId)(videoInputDeviceId);
              case 2:
                _t6 = _context.v;
                _context.n = 3;
                return (0, _deviceUtils.getMicrophoneNameFromId)(audioInputDeviceId);
              case 3:
                _t7 = _context.v;
                _t8 = notification.message;
                _t9 = _Vendor.VENDOR_CHIME;
                _t2({
                  meetingUserId: _t3,
                  presenterName: _t4,
                  presenterTitle: _t5,
                  cameraName: _t6,
                  microphoneName: _t7,
                  alertMessage: _t8,
                  meetingType: _t9
                });
              case 4:
                endMeetingAsHostCallback === null || endMeetingAsHostCallback === void 0 || endMeetingAsHostCallback({
                  meetingUserId: attendeeId
                });
                return _context.a(2, _objectSpread(_objectSpread({}, meeting), {}, {
                  attendeesList: attendeesList,
                  settings: settings
                }));
              case 5:
                _context.p = 5;
                _t0 = _context.v;
                endMeetingAsHostCallback === null || endMeetingAsHostCallback === void 0 || endMeetingAsHostCallback({
                  error: "Error creating broadcast meeting : ".concat(_t0)
                });
                throw _t0;
              case 6:
                return _context.a(2);
            }
          }, _callee, null, [[0, 5]]);
        }));
        function request(_x) {
          return _request.apply(this, arguments);
        }
        return request;
      }()
    };
    dispatch(action);
  });
}
var _default = exports["default"] = createMeeting;
function getPresenterAttendeeIds(attendeesList) {
  var presenterAttendees = attendeesList.Attendees.filter(function (_ref3) {
    var extId = _ref3.ExternalUserId;
    return extId.startsWith('Dr-') || extId.startsWith('Presenter-');
  });
  return presenterAttendees.map(function (attendee) {
    return attendee.AttendeeId;
  });
}